/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'open': {
    width: 6,
    height: 6,
    viewBox: '0 0 6 6',
    data: '<g transform="translate(0 .575)" _fill="#E48F00" fill-rule="evenodd"><circle pid="0" cx="4.75" cy="2.5" r="1"/><circle pid="1" opacity=".1" cx="2.5" cy="2.5" r="2.5"/></g>'
  }
})
